<template>
    <client-page>

        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Active & Legging Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Active & Legging Line" file="active">
                Single/Double knit with printing and foil design, Special pattern with
                Embossing, Very stretchy and recoverable quality. We have a lot of
                experience and buyers for these sports & Legging items. Offer your
                customers affordable and high-quality clothing.
            </sub-product>
        </sub-section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped>
</style>
